export default __webpack_public_path__ + "static/media/header.fc23dec5.jpg";